document.querySelectorAll('.sort-listbox label').forEach((label) => {
  if (label.textContent.includes('Alphabetically,')) {
    label.textContent = label.textContent
      .replace('Alphabetically, ', '') // Remove the word and comma
      .trim(); // Clean up any spaces
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Function to clean text
  const cleanAlphabetical = (el) => {
    if (el && el.textContent.includes('Alphabetically,')) {
      el.textContent = el.textContent.replace('Alphabetically, ', '').trim();
    }
  };

  // Clean the active selection button
  const selection = document.querySelector('.sort-selection');
  cleanAlphabetical(selection);

  // Clean the dropdown options
  document.querySelectorAll('.sort-listbox label').forEach((label) => cleanAlphabetical(label));

  // Observe for dynamic changes (like AJAX updates)
  const observer = new MutationObserver(() => {
    const updatedSelection = document.querySelector('.sort-selection');
    cleanAlphabetical(updatedSelection);
    document.querySelectorAll('.sort-listbox label').forEach((label) => cleanAlphabetical(label));
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  const cleanPrice = (el) => {
    if (el && el.textContent.includes("Price")) {
      el.textContent = el.textContent
        .replace("Price,", "")
        .replace("Price", "")
        .trim();
    }
  };

  // Initial cleanup for labels
  document.querySelectorAll(".sort-listbox label").forEach(label => cleanPrice(label));

  // Initial cleanup for active selection
  const selection = document.querySelector(".sort-selection");
  cleanPrice(selection);

  // Watch for changes (AJAX reloads or user clicks)
  const observer = new MutationObserver(() => {
    const updatedSelection = document.querySelector(".sort-selection");
    cleanPrice(updatedSelection);
    document.querySelectorAll(".sort-listbox label").forEach(label => cleanPrice(label));
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  const cleanDate = (el) => {
    if (el && el.textContent.includes("Date")) {
      el.textContent = el.textContent
        .replace("Date,", "")
        .replace("Date", "")
        .trim();
    }
  };

  // Initial cleanup for labels
  document.querySelectorAll(".sort-listbox label").forEach(label => cleanDate(label));

  // Initial cleanup for active selection
  const selection = document.querySelector(".sort-selection");
  cleanDate(selection);

  // Watch for changes (AJAX reloads or user clicks)
  const observer = new MutationObserver(() => {
    const updatedSelection = document.querySelector(".sort-selection");
    cleanDate(updatedSelection);
    document.querySelectorAll(".sort-listbox label").forEach(label => cleanDate(label));
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

(function () {
  function updateLabels(root) {
    // Defensive: ensure root is a DOM node with querySelectorAll
    if (!root || typeof root.querySelectorAll !== 'function') {
      root = document;
    }

    const labels = root.querySelectorAll(".loox-rating .loox-rating-label");
    labels.forEach(label => {
      // Prevent double updates
      if (label.dataset.reviewsEnhanced === "1") return;

      // Prefer the widget's own data-raters if present
      const widget = label.closest(".loox-rating.loox-widget");
      const countAttr = widget ? widget.getAttribute("data-raters") : null;
      let count = countAttr ? parseInt(countAttr, 10) : NaN;

      // Fallback: parse number from existing text
      if (isNaN(count)) {
        const num = (label.textContent || "").match(/\d+/);
        count = num ? parseInt(num[0], 10) : 0;
      }

      const word = count === 1 ? "REVIEW" : "REVIEWS";
      label.textContent = `(${count} ${word})`;
      label.dataset.reviewsEnhanced = "1";
    });
  }

  // Run once now
  updateLabels();

  // Run after page load as well
  window.addEventListener("load", updateLabels);

  // Observe for Loox injecting or updating widgets
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.type === "childList") {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (
            node.matches?.(".loox-rating, .loox-rating .loox-rating-label") ||
            node.querySelector?.(".loox-rating .loox-rating-label")
          ) {
            updateLabels(node);
          }
        });
      } else if (
        m.type === "attributes" &&
        m.target?.nodeType === 1 &&
        m.target.matches?.(".loox-rating.loox-widget")
      ) {
        // If Loox changes data-raters on an existing widget
        updateLabels(m.target);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["data-raters"]
  });
})();

(function () {
  const isIOS = /iP(hone|ad|od)/.test(navigator.platform)
    || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  if (!isIOS) return;

  const ROOT = 'details.product__accordion.details';
  const CONTENT = '.details__content';
  const CLEAR_PROPS = ['opacity','transform','transition','willChange','height','overflow','maxHeight'];

  const clear = el => CLEAR_PROPS.forEach(p => { try { el.style[p] = ''; } catch(_){} });

  const applyOpen = (content) => {
    content.style.display = 'block';
    content.style.maxHeight = '100%';
    content.style.height = 'auto';
    content.style.overflow = 'visible';
    content.style.transform = 'none';
    content.style.opacity = '1';
    content.style.transition = 'none';
    content.style.willChange = 'auto';
  };

  const applyClose = (content) => {
    // Immediate hide prevents the one second lag on iOS
    content.style.display = 'none';
    clear(content);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(ROOT).forEach(details => {
      const content = details.querySelector(CONTENT);
      if (!content) return;

      // Normalize on load
      if (details.hasAttribute('open')) applyOpen(content);
      else applyClose(content);

      // Instant state switch
      details.addEventListener('toggle', () => {
        if (details.open) {
          applyOpen(content);
        } else {
          applyClose(content);
        }
      });

      // If any script re-adds inline styles, wipe them
      new MutationObserver(muts => {
        for (const m of muts) {
          if (m.type === 'attributes' && m.attributeName === 'style') {
            if (details.open) applyOpen(content);
            else applyClose(content);
          }
        }
      }).observe(content, { attributes: true, attributeFilter: ['style'] });
    });
  });
})();